import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Platform } from '@ionic/angular';
import { IDEATranslationsService } from '@idea-ionic/common';

import { AppService } from './app.service';

import { ServiceLanguages } from '@models/serviceLanguages.enum';

declare const IRoot: any;

export const initGuard: CanActivateFn = async (): Promise<boolean> => {
  const platform = inject(Platform);
  const t = inject(IDEATranslationsService);
  const app = inject(AppService);

  const shouldCheckForRootedDevice = (): boolean => {
    return platform.is('cordova') && typeof IRoot !== 'undefined' && IRoot;
  };
  const isDeviceRooted = async (): Promise<boolean> => {
    return new Promise(resolve =>
      IRoot.isRooted((isRooted: boolean): void => {
        if (isRooted) {
          alert('Rooted device');
          resolve(true);
        } else {
          app.initReady = true;
          resolve(false);
        }
      })
    );
  };

  if (app.initReady) return true;

  await platform.ready();

  await t.init(Object.values(ServiceLanguages), ServiceLanguages.Italian);

  app.customIconsPath = '/assets/icons/global';

  if (shouldCheckForRootedDevice()) return !(await isDeviceRooted());

  app.initReady = true;

  return true;
};
